import axios from 'axios';

export default {
	loadDays() {
		return axios.get(`/api/days?from=past&to=planning&sort=date&fields=date`);
	},
	loadBasicFitness(dayId) {
		return axios.get(`/api/basicfitness/${dayId}`);
	},
	loadUsers(userIds) {
		return axios.post('/api/users/fetch-multiple', { ids: userIds });
	},
	loadDuties(date) {
		return axios.post('/api/duties/days', { from: date, to: date });
	},
	calculateBasicFitness() {
		return axios.get('/api/basicfitness/calculate');
	},
};
